import React from "react";
import Modal from "app/components/Modal";
import Button from "app/components/Button";
import { useSelector } from "react-redux";
import { selectIsArchiveLoading } from "app/redux/selector";

interface ArchiveModalProps {
  onClose: () => void;
  onSave: () => void;
  readonly content: string;
  readonly title: string;
  readonly backButtonText?: string;
  readonly saveButtonText?: string;
}

const ArchiveModalWrapper: React.FC<ArchiveModalProps> = ({
  onSave,
  content,
  onClose,
  title,
  backButtonText = "Cancel",
  saveButtonText = "Archive",
}) => {
  const loading = useSelector(selectIsArchiveLoading);
  return (
    <Modal
      title={title}
      onClose={() => onClose()}
      submitText="Archive"
      insetClassName="bg-[#0000004D]"
      modalClassName="flex flex-col items-center p-0 gap-[0] absolute w-[400px] left-[50%] top-[50%] transform -translate-x-1/2 -translate-y-1/2 bg-white border border-[#E9ECF2] rounded-lg"
      optionalFooterClass="bg-[#F4F5F7] rounded-b-md px-6 py-4"
      contentClassName=" flex items-center "
      renderModalFooter={
        <div className="flex justify-end gap-3">
          <Button
            className="!bg-[transparent]  border border-secondary rounded !text-secondary h-[36px] text-sm font-medium w-[106px]"
            onClick={() => onClose()}
          >
            {backButtonText}
          </Button>
          <Button
            className="text-sm font-medium rounded bg-primary text-white h-[36px] w-[106px]"
            isLoading={loading}
            onClick={() => {
              onSave();
            }}
          >
            {saveButtonText}
          </Button>
        </div>
      }
    >
      <p
        className="test-sm font-normal text-left text-secondary "
        dangerouslySetInnerHTML={{ __html: content as string }}
      ></p>
    </Modal>
  );
};

export default ArchiveModalWrapper;
